import Cryptr from 'cryptr';
import { Env } from '@/env';

const cryptr = new Cryptr(Env.getEncryptKey(), {
  pbkdf2Iterations: 1000,
});

export class AuthUtil {
  static encryptBearerToken(token) {
    return cryptr.encrypt(token);
  }
}
